import React from 'react';
import { columns } from './columns/index';
import { StyledContainer } from './styles';
import { FORM_SEARCH, searchDefaultValue } from './forms';
import { TextLarge, CardTheme } from '../../../components/index';
import { Icon } from '../../../resources';
import ButtonExcelEmbedded from '../../../components/report-excel/ButtonExcelEmbedded';
import { ContainerButton } from '../../../styles/global-style';
import { useGetMember } from './hooks/useGetMember';
import { useForm } from 'react-hook-form';
import { ResponsivePageLayout } from '../../../components/page-layout/ResponsivePageLayout';
import { useGetFullMember } from './hooks/useGetFullMember';
import { SpaceBetween } from '../../manage-data/user-info/styles';
import { RowSearchLayout } from '../../../components/page-layout/views/RowSearchLayout';
import { useEffect, useState } from 'preact/hooks';

export const ReportMember = () => {
  const [searchType, setSearchType] = useState(null);
  const formSearchObj = useForm({ defaultValues: searchDefaultValue });
  const {
    dataSource: memberData,
    onSearch,
    loading: isPendingMember,
  } = useGetMember({
    handleSubmit: formSearchObj.handleSubmit,
  });
  const {
    dataSource: fullMemberData,
    onSearchFull,
    loading: isPendingFullMember,
  } = useGetFullMember({
    handleSubmit: formSearchObj.handleSubmit,
  });

  useEffect(() => {
    onSearch(searchDefaultValue);
  }, []);

  const onSearchByField = (values) => {
    if (values.search) {
      setSearchType('search');
      onSearchFull(values);
    } else if (values.startDate) {
      setSearchType('date');
      onSearch(values);
    }
  };

  const formSearch = FORM_SEARCH({ onEnter: formSearchObj.handleSubmit(onSearchByField) });
  return (
    <StyledContainer>
      <TextLarge text="รายงานสมัครเมมเบอร์" />
      <CardTheme>
        <RowSearchLayout
          props={{
            title: 'รายงานสมัครเมมเบอร์',
            formSearch,
            useFormParam: formSearchObj,
            icon: <Icon.todo />,
            onSearch: formSearchObj.handleSubmit(onSearchByField),
            ignoreDateEmpty: true,
          }}
        ></RowSearchLayout>
        <ResponsivePageLayout
          tableLayout={{
            columns: columns(),
            dataSource: searchType === 'search' ? fullMemberData : memberData,
            hasPagination: true,
            loading: isPendingMember || isPendingFullMember,
            extraContent: (
              <SpaceBetween>
                <ContainerButton right>
                  <ButtonExcelEmbedded
                    title="Export"
                    header={columns()}
                    data={searchType === 'search' ? fullMemberData : memberData}
                    filename="รายงานรายการสมัครเมมเบอร์"
                  />
                </ContainerButton>
              </SpaceBetween>
            ),
          }}
        />
      </CardTheme>
    </StyledContainer>
  );
};
